import './style.css';

import React from 'react';
import QuickPickMulti from '../multi-mode';
import QuickPickRaw from '../raw-mode';

class QuickPickLive extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
    this.onNavigate = this.onNavigate.bind(this);

    this.state = {
      selected: !!props.startMenu ? props.startMenu : 'main'
    };
  }

  render() {
    let { open, multiSelect } = this.props;

    if (!open) {
      return <div />;
    }

    let quickPicks = !!multiSelect ? (
      <QuickPickMulti
        {...this.props}
        {...this.state}
        onChange={this.onChange}
        onNavigate={this.onNavigate}
      />
    ) : (
      <QuickPickRaw
        {...this.props}
        {...this.state}
        onChange={this.onChange}
        onNavigate={this.onNavigate}
      />
    );

    return <div className="quick-pick live-mode">{quickPicks}</div>;
  }

  onNavigate(key) {
    if (key == '') key = 'main';
    this.setState({ selected: key });
  }

  onChange(key, value) {
    if (!this.props.appendMulti && !this.props.multiSelect) {
      this.setState({ selected: 'main' });
      this.props.onRequestClose();
    }

    this.props.onChange(value, key);
  }
}

QuickPickLive.defaultProps = {
  onChange: () => {},
  onRequestClose: () => {}
};

export default QuickPickLive;

export const { defaultProps } = QuickPickLive;
